import { render, staticRenderFns } from "./UserPostList.vue?vue&type=template&id=1b470697&scoped=true&"
import script from "./UserPostList.vue?vue&type=script&lang=js&"
export * from "./UserPostList.vue?vue&type=script&lang=js&"
import style0 from "./UserPostList.vue?vue&type=style&index=0&id=1b470697&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b470697",
  null
  
)

export default component.exports